import { render } from "./Specialized medical councils.vue?vue&type=template&id=3883a330&scoped=true"
const script = {}

import "./Specialized medical councils.vue?vue&type=style&index=0&id=3883a330&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-3883a330"

export default script